import { render, staticRenderFns } from "./gestao.vue?vue&type=template&id=093c730c&scoped=true&"
import script from "./gestao.vue?vue&type=script&lang=js&"
export * from "./gestao.vue?vue&type=script&lang=js&"
import style0 from "./gestao.vue?vue&type=style&index=0&id=093c730c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c730c",
  null
  
)

export default component.exports